import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';
import { CALENDAR_POPOUT_OPTIONS } from './popoutCalendarCompose';

export default function popoutCalendarReadingPane(
    calendarItemId: string,
    actionSource: string,
    data?: Object,
    source?: AddPopoutSource
) {
    const route = 'read/' + encodeURIComponent(calendarItemId);
    addPopoutV2(
        'calendar',
        route,
        { ...data, entrySource: actionSource },
        CALENDAR_POPOUT_OPTIONS,
        false /* skipOptinCheck */,
        actionSource
    );
}
